export default "<input type=\"text\" [attr.class]=\"defaultCss\" [(ngModel)]=\"value\" (ngModelChange)=\"inputChanged($event)\" />"